<template>
  <div class="page">
    <epp-banner :type="2"></epp-banner>
    <!-- <div class="box">
      <div class="box1">
        <img class="bg" :src="cdnUrl+'eppendorf/centrifuge_bg1.png'" alt="">
        <div class="title">台式离心机</div>
        <div class="txt">安全高效 轻松离心</div>
      </div>
      <div class="box1">
        <img class="bg" :src="cdnUrl+'eppendorf/centrifuge_bg2.png'" alt="">
        <div class="title">落地高速/超速离心机</div>
        <div class="txt">超高转速 精准分离</div>
      </div>
    </div> -->
    <div class="menu-main">
      <div class="menu-bottom">
        <div class="left" @click="gotoDetail('operateUse', 1)">
          <p class="txt">台式离心机</p>
          <p class="col">安全高效 轻松离心</p>
          <img :src="cdnUrl + 'centrifugeTableModel.png'">
        </div>
        <div class="right" @click="gotoDetail('operateUse', 2)">
          <p class="txt">落地高速/超速离心机</p>
          <p class="col">超高转速 精准分离</p>
          <img :src="cdnUrl + 'centrifugeSuperdissociation2.png'">
        </div>
      </div>
    <img class="news" v-if="list.length>0" :src="cdnUrl+'eppendorf/news_bg1.jpg'" alt="" @click="goNewSpecial()">
      <!-- <div class="menu-top" @click="gotoDetail('https://www.eppendorf.com/zh/your-centrifuge-solution/')">
        <div class="left">
          <p class="txt">一键启动，轻松离心</p>
          <p class="col">专注离心 60 年，值得信赖</p>
          <p class="line"></p>
        </div>
        <div>
          <img class="pro-img" :src="cdnUrl + 'centrifugeLogo3.png'">
        </div>
      </div> -->
    </div>
    <!-- <footerLine></footerLine> -->
  </div>
</template>

<script>
import eppBanner from '@/components/eppBanner'
import footerLine from '@/components/footerLine'
import { centrifugeRecord } from '@/libs/common'
import { createdLabel } from '@/api/centrifuge'
import { getNewSpecialList } from '@/api/newSpecial'
export default {
  components: {
    eppBanner,
    footerLine
  },
  data() {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      list:[]
    }
  },
  created() {
    let para = {
      type: 34, // 离心机首页记录
      type_id: 0,
      uid: this.$store.state.user.id || 0,
      action: 1
    }
    centrifugeRecord(para) // 人数，次数记录
    this.setLabel()
    this.getList()
  },
  methods: {
    getList(){
        var para={}
        getNewSpecialList(para).then(res => {
          this.list = res.data.data
        })
    },
    goNewSpecial(){
      this.$router.push('/newSpecial');
    },
    setLabel() {
      let para = {
        openid: this.$store.state.user.openid,
        tag_ids: [231,232] // [226,227] --> 测试   [231,232] --> 正式
      }
      createdLabel(para).then(res => {})
    },
    gotoDetail(name, centrifugeType) {
      if (name.includes("http")) {
        window.location.href = name;
      } else {
        let query = centrifugeType ? { centrifugeType } : {};
        this.$router.push({ name, query });
      };
      this.recordHome(name)
    },
    recordHome(name) {
      switch (name){
        case 'cenProgramme':
          this.type = 9
          break;
        default: 
          this.type = 8
      }
      let para = {
        type: this.type, // 
        type_id: 0,
        uid: this.$store.state.user.id || 0,
        action: 1
      }
      centrifugeRecord(para) // 人数，次数记录
    }
  }
}
</script>

<style lang="scss" scoped>
.page{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.col {
  font-size: rem(12);
  padding: 0 rem(10) 0 0;
  color: #999999;
  margin-top: rem(4);
}
.txt {
  font-size: rem(14);
  color: #333333;
  font-weight: bold;
}
.news{
  width: 4.62rem;
  margin-top: rem(16);
  border-radius: rem(10);
}
.box{
  width: 4.62rem;
  margin-top: rem(14);
  display: flex;
  justify-content: space-between;
  .box1{
    width: rem(165);
    height: rem(204);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    .bg{
      width: rem(165);
      height: rem(204);
      position: absolute;
      top: 0;
      left: 0;
    }
    .title{
      font-weight: bold;
      font-size: rem(16);
      color: #292929;
      line-height: rem(22);
      position: relative;
    }
    .txt{
      font-size: rem(12);
      color: #666666;
      line-height: rem(17);
      margin-top: rem(5);
      margin-bottom: rem(14);
      position: relative;
    }
  }
}
.menu-main {
  .menu-top {
    display: flex;
    justify-content: space-between;
    width: rem(345);
    height: rem(114);
    margin: 0 auto;
    margin-top: rem(15);
    background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
    border-radius: 4px;
    border: 1px solid rgba(103,195,216,0.3);
    .pro-img {
      margin: rem(14) rem(13) 0 0;
      width: rem(102);
      height: rem(87);
    }
    .left {
      position: relative;
      padding-left: rem(20);
    }
    .txt {
      margin-top: rem(30);
    }
    .line {
      position: absolute;
      bottom: rem(28);
      width: rem(126);
      height: rem(2);
      background: rgba(108,197,219,0.35);
      border-radius: 4px;
    }
  }
  .menu-bottom {
    display: flex;
    justify-content: center;
    margin-top: rem(16);
    .left {
      position: relative;
      width: rem(165);
      height: rem(175);
      padding: rem(12) 0 0 rem(12);
      margin-right: rem(15);
      background-image: url('https://cdn.juplus.cn/centrifugeBg.png');
      background-size: cover;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.07);
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid rgba(103,195,216,0.3);
      img {
        position: absolute;
        right: rem(8);
        bottom: rem(8);
        width: rem(90);
        height: rem(90);
      }
    }
    .right {
      position: relative;
      width: rem(165);
      height: rem(175);
      padding: rem(12) 0 0 rem(12);
      background-image: url('https://cdn.juplus.cn/centrifugeBg.png');
      background-size: cover;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid rgba(103,195,216,0.3); 
      img {
        position: absolute;
        right: rem(22);
        bottom: rem(15);
        width: rem(68);
        height: rem(74);
      }
    }
  }
}
</style>